<script>
import EventBus from './../eventBus.js'
import get from 'lodash/get'


export default {
  name: 'campaign-block',
  props: {
    target: {
        type: Number,
        required: false,
        default: 0,
    },

    donatedAmount: {
        type: Number,
        required: false,
        default: 0,
    },
  },
  components: {

  },
  data() {
    return {

    }
  },
  mounted() {

  },
  computed: {
      targetPercentage() {
          return Math.round(this.donatedAmount / this.target * 100);
      }
  },
  methods: {

  },
  watch: {

  }
}
</script>
